import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';
import { MarkupField } from '~src/spacesPlatform/components/Explorer/widgets/MarkupField';
import { Name } from '~src/spacesPlatform/components/tooltip/Name';
import { Timestamp } from '~src/spacesPlatform/components/tooltip/Timestamp';
import { Tooltip } from '~src/spacesPlatform/components/tooltip/Tooltip';
import { ContentTooltipProps, TooltipDescriptionTestId } from '~src/spacesPlatform/components/tooltip/TooltipHelper';
import { User } from '~src/spacesPlatform/components/tooltip/User';

export function CollectionTooltip(props: ContentTooltipProps): JSX.Element {

  return (
    <Tooltip>
      <Name name={props.content.name} />
      <MarkupField markup={props.content.description}
                   testId={TooltipDescriptionTestId}
                   extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]} />
      <User user={props.content.owner} label={Messages.owner()} urls={props.urls} />
      <Timestamp label={Messages.modified()} value={props.content.updatedAt} />
    </Tooltip>
  );
}
